import { IShiftIdentifierPolicyReducer, IShiftIdentifierPolicy } from 'models/ShiftIdentifierPolicy'
import { isType } from 'ts-action'
import { Action } from 'redux'
import {
  GetShiftIdentifierPolicy,
  GetShiftIdentifierPolicyErrors,
  ClearShiftIdentifierPolicy,
  DeleteShiftIdentifierPolicy,
  ShiftIdentifierPolicyFetching,
  AddShiftIdentifierPolicy,
  UpdateShiftIdentifierPolicy,
} from './actions'

const initialState: IShiftIdentifierPolicyReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: {} as IShiftIdentifierPolicy,
}

export const shiftIdentifierPolicyReducer = (
  state = initialState,
  action: Action
): IShiftIdentifierPolicyReducer => {
  if (isType(action, GetShiftIdentifierPolicy)) {
    const { payload } = action
    return {
      ...state,
      meta: payload.meta,
      data: payload.data,
    }
  }

  if (isType(action, GetShiftIdentifierPolicyErrors)) {
    const { payload } = action
    return {
      ...state,
      error: {
        code: payload.code,
        message: payload.message,
      },
    }
  }

  if (isType(action, DeleteShiftIdentifierPolicy)) {
    return {
      meta: {
        code: 0,
        message: '',
      },
      isFetching: false,
      data: {} as IShiftIdentifierPolicy,
    }
  }
  if (isType(action, ClearShiftIdentifierPolicy)) {
    return {
      meta: {
        code: 0,
        message: '',
      },
      isFetching: false,
      data: {} as IShiftIdentifierPolicy,
    }
  }

  if (isType(action, ShiftIdentifierPolicyFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }

  if (isType(action, AddShiftIdentifierPolicy)) {
    const { payload } = action
    return {
      ...state,
      data: payload.data,
    }
  }

  if (isType(action, UpdateShiftIdentifierPolicy)) {
    const { payload } = action
    return {
      ...state,
      data: payload.data,
    }
  }

  return state
}
